// eslint-disable-next-line no-unused-vars
import React from "react";
import { getSolutionsCodesOneMobility } from "../../../services/api/hubcatalog/one-mobility-service";
import { uploadFileVehicles } from "../../../services/api/hubcatalog/one-mobility-single-registry-service";

import {
  VehicleSingleRegistryUploadBase,
  defaultIntlMessages,
} from "../admin/VehicleSingleRegistryUpload";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { Box, ThemeProvider } from "@material-ui/core";
import { default as themeDefault } from "../../../theme";

import HUBContext from "../../../services/HUBContext";
import { SingleRegistryView } from "../../../components/single-registry/view/SingleRegistryView";
import NavigationConfirmationModal from "../../../components/single-registry/modals/NavigationConfirmationModal";
import Loader from "../../../helpers/loader-full";
import { ROUTER_MAP_PATH } from "../../../EmbeddedRoutes";
import SolutionStepWidget from "./SolutionStepWidget";
import UploadFileWidget from "./UploadFileWidget/UploadFileWidget";
import UploadFileConclusionWidget from "./UploadFileConclusionWidget/UploadFileConclusionWidget";
import { uploadStatusEnum } from "../../../components/single-registry/enums/status-upload";
import { trackEvent, trackException } from "../../../services/telemetry/appInsights";

const styles = {
  uploadContainer: {
    flex: "1",
    padding: "20px",
  },
};

export class VehicleSingleRegistryUploadWidget extends VehicleSingleRegistryUploadBase {
  includeDefaultSolution = false;

  getVehiclesModulePath() {
    return ROUTER_MAP_PATH.vehicles.homePage.replace(
      ":cid",
      this.props?.match?.params.cid,
    );
  }

  getDashboardPath() {
    return ROUTER_MAP_PATH.vehicles.homePage.replace(
      ":cid",
      this.props?.match?.params.cid,
    );
  }

  solutionsCodes = this.getSolutionsCodesOneMobilityPipe().bind(this);

  getSolutionsCodesOneMobilityPipe() {
    const companyId = this.props?.match?.params.cid;

    return async (integratorSolutionId) => {
      this.toggleLoding();

      try {
        const response = await getSolutionsCodesOneMobility(companyId, integratorSolutionId,);

        return response.data;
      } catch (error) {
        return [];
      } finally {
        this.toggleLoding();
      }
    };
  }

  async uploadFileVehiclesHandler() {
      const integratorSolutionCodes = [];
      for (const [solutionId, integratorCodes] of this.state
        .solutionsCodesSelected) {
        const solution = this.state.allSolutions.find((s) => s.id === solutionId);
        if (solution) {
          integratorSolutionCodes.push({
            solutionCode: solution.code,
            integratorCode: integratorCodes,
          });
        }
      }
  
      const companyId = this.props?.match?.params.cid;
      const solutionCodesSerialized = JSON.stringify({ integratorSolutionCodes });
  
      this.toggleLoding();
  
      this.setState({
        status: uploadStatusEnum.SENDING,
        percent: 0,
        hasErrorUpload: false,
        uploadErrorMessage: "",
      });
  
      const formData = new FormData();
      formData.append("file", this.state.uploadedFile);
      formData.append(
        "integratorSolutionCodesSerialized",
        solutionCodesSerialized,
      );
      try {
        const res = await uploadFileVehicles(
          companyId,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (e) => {
              if (e.total) {
                const percent = Math.round((e.loaded * 100) / e.total);
                this.setState({ percent, status: "sending" });
              }
            },
          },
          this.context.locale,
        );
  
        trackEvent("SingleRegistry_FileUploadCompleted", {
          companyId,
          hasError: res.data.hasError,
          vehicleCount: res.data?.data?.length || 0,
          errorMessage: res.data.errorMessage,
        });
  
        this.setState({
          percent: 100,
          status: uploadStatusEnum.COMPLETED,
          hasErrorUpload: res.data.hasError,
          uploadErrorMessage: res.data.errorMessage,
          resumeUploadFileResponse: res.data,
          companyUploadId: res.data.companyUploadId,
        });
        return true;
      } catch (error) {
        const errorMessage = error?.response?.data ?? error?.message;
  
        trackException(error, {
          companyId,
          action: "uploadFileVehicles",
          errorStatus: error.response?.status,
          errorDetails:
            typeof errorMessage === "string"
              ? errorMessage
              : JSON.stringify(errorMessage),
        });
  
        this.setState({
          uploadedFile: null,
          percent: 0,
          status: uploadStatusEnum.STOPPED,
          hasErrorUpload: true,
          uploadErrorMessage:
            typeof errorMessage === "string"
              ? errorMessage
              : JSON.stringify(errorMessage),
        });
      } finally {
        this.toggleLoding();
      }
    }

  solutionStep() {
    return {
      ...super.solutionStep(),
      actions: {
        ...super.solutionStep()?.actions,
        next: {
          ...super.solutionStep()?.actions?.next,
          isDisabled: () => {
            const solutionsCodeSelected = [
              ...this.state.solutionsCodesSelected.keys(),
            ];

            if (solutionsCodeSelected.length === 0) {
              return true;
            }

            return [...this.state.activeSolutions.keys()].some((solutionId) => {
              if (solutionId === "gohub") {
                return false;
              }

              const selectedCodes =
                this.state.solutionsCodesSelected.get(solutionId);

              return !selectedCodes || selectedCodes.length === 0;
            });
          },
        },
      },
      component: (
        <SolutionStepWidget
          includeDefaultSolution={this.includeDefaultSolution}
          solutionsSelected={this.state.solutionsSelected}
          solutionsCodesSelected={this.state.solutionsCodesSelected}
          getSolutions={this.solutions}
          getSolutionsCodes={this.solutionsCodes}
          onSolutionsCodesChanges={this.setSolutionsCodes.bind(this)}
          onSolutionToggle={this.handleSolutionToggle.bind(this)}
        />
      ),
    };
  }

  uploadStep() {
    return {
      ...super.uploadStep(),
      component: (
        <UploadFileWidget
          onFileChange={this.handleFileChange.bind(this)}
          hasErrorUpload={this.state.hasErrorUpload}
          uploadErrorMessage={this.state.uploadErrorMessage}
          percent={this.state.percent}
          status={this.state.status}
          companyId={this.props?.match?.params.cid}
          integratorsSolutionsCode={this.getIntegratorSolutionCodes()}
        />
      ),
    };
  }

  conclusionStep() {
    return {
      ...super.conclusionStep(),
      component: (
        <UploadFileConclusionWidget
          itemsChanged={this.state.resumeUploadFileResponse?.data?.length}
          hasSolutions={this.state.solutionsCodesSelected.size > 0}
        />
      ),
      actions: {
        ...super.conclusionStep()?.actions,
        prev: {
          ...super.conclusionStep()?.actions?.prev,
          isShow: false,
        },
        next: null,
      },
    };
  }

  render() {
    const { intl, theme } = this.props;
    return (
      <ThemeProvider theme={theme ?? themeDefault}>
        <Box sx={styles.uploadContainer}>
          {this.state.isLoading && <Loader edenredLogo={true} full={true} />}
          <SingleRegistryView
            stepClickDisabled={true}
            modulePath="/vehicles"
            hasHeader={false}
            title={intl?.formatMessage(defaultIntlMessages.title) ?? ""}
            steppers={this.getSteppers()}
          />
          <NavigationConfirmationModal
            open={this.state.isConfirmationModalOpen}
            title={intl?.formatMessage(defaultIntlMessages.uploadModalTitle)}
            message={intl?.formatMessage(
              defaultIntlMessages.uploadModalMessage,
            )}
            primaryButtonText={intl?.formatMessage(
              defaultIntlMessages.uploadModalStay,
            )}
            secondaryButtonText={intl?.formatMessage(
              defaultIntlMessages.uploadModalReturn,
            )}
            onPrimaryClick={this.handleCloseConfirmationModal.bind(this)}
            onSecondaryClick={this.handleConfirmNavigation.bind(this)}
          />
        </Box>
      </ThemeProvider>
    );
  }
}

VehicleSingleRegistryUploadWidget.contextType = HUBContext;
VehicleSingleRegistryUploadWidget = withRouter(
  VehicleSingleRegistryUploadWidget,
);
export default injectIntl(VehicleSingleRegistryUploadWidget);
